import { toast } from "react-toastify";

import * as XLSX from "xlsx";
import imageCompression from "browser-image-compression";

const data_type = [
  "data:application/pdf;",
  "data:application/msword;",
  "data:application/vnd.ms-excel;",
  "data:image/jpeg;",
  "data:image/png;",
  "data:application/x-7z-compressed;",
  "data:application/zip;",
  "data:application/x-rar-compressed;",
];

const checkDataPelanggan = (req, y) => {
  const data = req.filter((m) =>
    m ? m.pelanggan_id === y.pelanggan_id : false,
  );
  return data.length === 0 ? null : data[0];
};

const checkDataKaryawan = (req, y) => {
  const data = req.filter((m) => (m ? m.karyawan_id === y.karyawan_id : false));
  return data.length === 0 ? null : data[0];
};

const checkDataPaket = (req, y) => {
  const data = req.filter((m) => (m ? m.paket_id === y.paket_id : false));
  return data.length === 0 ? null : data[0];
};

const checkDataKost = (req, y) => {
  const data = req.filter((m) => (m ? m.kost_id === y.kost_id : false));
  return data.length === 0 ? null : data[0];
};

const checkDataClustermahasiswa = (req, y) => {
  const data = req.filter((m) => m.cluster_mahasiswa_id === y.cluster_id);
  return data.length === 0 ? null : data[0];
};

const checkDataClusterresidential = (req, y) => {
  const data = req.filter((m) => m.cluster_residential_id === y.cluster_id);
  return data.length === 0 ? null : data[0];
};

const checkDataRequest = (req, y) => {
  const data = req.filter((m) => (m ? m.request_id === y.request_id : false));
  return data.length === 0 ? null : data[0];
};

const checkDataPicSurvey = (req, y) => {
  const data = req.filter((m) => (m ? m.karyawan_id === y.pic_survey : false));
  return data.length === 0 ? null : data[0];
};

const formatDataMahasiswa = (x) => {
  //cek mahasiswa
  const dataKost = x.kost_info;
  const dataSales = x.sales_info;
  const dataClustermahasiswa = x.cluster_info;
  return {
    nim: x.nim,
    nama: x.nama,
    no_ktp: x.no_ktp,
    no_kamar: x.no_kamar,
    no_hp: x.no_hp,
    email: x.email,
    info: x.info,
    nama_kost: dataKost.nama,
    alamat_kost: dataKost.alamat,
    kelurahan_kost: dataKost.kelurahan ?? "",
    jumlah_kamar_kost: dataKost.jumlah_kamar ?? "",
    nama_pemilik_kost: dataKost.nama_pemilik ?? "",
    hp_pemilik_kost: dataKost.hp_pemilik ?? "",
    nama_pengelola_kost: dataKost.nama_pengelola ?? "",
    hp_pengelola_kost: dataKost.hp_pengelola ?? "",
    status_kemitraan_kost: dataKost.status_kemitraan ?? "",
    masa_berlaku_mitra_kost: dataKost.masa_berlaku_mitra ?? "",
    no_pks_kost: dataKost.no_pks ?? "",
    nama_cluster_cluster: dataClustermahasiswa
      ? dataClustermahasiswa.nama_cluster
      : "",
    nik_karyawan: dataSales ? dataSales.nik : "",
    nama_karyawan: dataSales ? dataSales.name : "",
  };
};

export const convertDataToExcelMahasiswa = (dataMahasiswa) => {
  const record = dataMahasiswa.map((x) => formatDataMahasiswa(x));
  const wscols = [
    { wch: Math.max(...record.map((x) => (x.nim ? x.nim.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.no_ktp ? x.no_ktp.length : 0))) },
    {
      wch: Math.max(...record.map((x) => (x.no_kamar ? x.no_kamar.length : 0))),
    },
    { wch: Math.max(...record.map((x) => (x.no_hp ? x.no_hp.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.email ? x.email.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.info ? x.info.length : 0))) },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.alamat_kost ? x.alamat_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.kelurahan_kost ? x.kelurahan_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.jumlah_kamar_kost ? x.jumlah_kamar_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.nama_pemilik_kost ? x.nama_pemilik_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.hp_pemilik_kost ? x.hp_pemilik_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.nama_pengelola_kost ? x.nama_pengelola_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.hp_pengelola_kost ? x.hp_pengelola_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.status_kemitraan_kost ? x.status_kemitraan_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.masa_berlaku_mitra_kost ? x.masa_berlaku_mitra_kost.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.no_pks_kost ? x.no_pks_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.nama_cluster_cluster ? x.nama_cluster_cluster.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nik_karyawan ? x.nik_karyawan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_karyawan ? x.nama_karyawan.length : 0)),
      ),
    },
  ];
  const multiDataSet = {
    header: [
      "NIM",
      "Nama",
      "No KTP",
      "No Kamar",
      "No HP",
      "Email",
      "Sumber Info",
      "Nama Kost",
      "Alamat Kost",
      "Kelurahan Kost",
      "Jumlah Kamar Kost",
      "Pemilik Kost",
      "No HP Pemilik Kost",
      "Pengelola Kost",
      "No HP Pengelola Kost",
      "Status Kemitraan Kost",
      "Masa Berlaku Kemitraaan Kost",
      "No PKS Kost",
      "Nama Cluster",
      "NIK Sales",
      "Nama Sales",
    ],
    heading: [
      {
        nim: "NIM",
        nama: "Nama",
        no_ktp: "No KTP",
        no_kamar: "No Kamar",
        no_hp: "No HP",
        email: "Email",
        info: "Sumber Info",
        nama_kost: "Nama Kost",
        alamat_kost: "Alamat Kost",
        kelurahan_kost: "Kelurahan Kost",
        jumlah_kamar_kost: "Jumlah Kamar Kost",
        nama_pemilik_kost: "Pemilik Kost",
        hp_pemilik_kost: "No HP Pemilik Kost",
        nama_pengelola_kost: "Pengelola Kost",
        hp_pengelola_kost: "No HP Pengelola Kost",
        status_kemitraan_kost: "Status Kemitraan Kost",
        masa_berlaku_mitra_kost: "Masa Berlaku Kemitraaan Kost",
        no_pks_kost: "No PKS Kost",
        nama_cluster_cluster: "Nama Cluster",
        nik_karyawan: "NIK Sales",
        nama_karyawan: "Nama Sales",
      },
    ],
    csvHeader: [
      { label: "NIM", key: "nim" },
      { label: "Nama", key: "nama" },
      { label: "No KTP", key: "no_ktp" },
      { label: "No Kamar", key: "no_kamar" },
      { label: "No HP", key: "no_hp" },
      { label: "Email", key: "email" },
      { label: "Sumber Info", key: "info" },
      { label: "Nama Kost", key: "nama_kost" },
      { label: "Alamat Kost", key: "alamat_kost" },
      { label: "Kelurahan Kost", key: "kelurahan_kost" },
      { label: "Jumlah Kamar Kost", key: "jumlah_kamar_kost" },
      { label: "Pemilik Kost", key: "nama_pemilik_kost" },
      { label: "No HP Pemilik Kost", key: "hp_pemilik_kost" },
      { label: "Pengelola Kost", key: "nama_pengelola_kost" },
      { label: "No HP Pengelola Kost", key: "hp_pengelola_kost" },
      { label: "Status Kemitraan Kost", key: "status_kemitraan_kost" },
      { label: "Masa Berlaku Kemitraaan Kost", key: "masa_berlaku_mitra_kost" },
      { label: "No PKS Kost", key: "no_pks_kost" },
      { label: "Nama Cluster", key: "nama_cluster_cluster" },
      { label: "NIK Sales", key: "nik_karyawan" },
      { label: "Nama Sales", key: "nama_karyawan" },
    ],
    fileName: "Data_Mahasiswa",
    csvFileName: "Data_Mahasiswa.csv",
    wscols: wscols,
    csvData: record,
  };
  return multiDataSet;
  //return newBlob;
};

const formatDataResidential = (x) => {
  //cek mahasiswa
  const dataSales = x.sales_info;
  const dataClusterresidential = x.cluster_info;
  return {
    created_at: x.created_at,
    nama: x.nama,
    no_ktp: x.no_ktp,
    alamat: x.alamat,
    rw: x.rw,
    rt: x.rt,
    no_hp: x.no_hp,
    email: x.email,
    info: x.info,
    nama_cluster: dataClusterresidential
      ? dataClusterresidential.nama_cluster
      : "",
    nik_karyawan: dataSales ? dataSales.nik : "",
    nama_karyawan: dataSales ? dataSales.name : "",
  };
};

export const convertDataToExcelResidential = (dataResidential) => {
  const record = dataResidential.map((x) => formatDataResidential(x));
  const wscols = [
    {
      wch: Math.max(
        ...record.map((x) => (x.created_at ? x.created_at.length : 0)),
      ),
    },
    { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.no_ktp ? x.no_ktp.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.rw ? x.rw.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.rt ? x.rt.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.no_hp ? x.no_hp.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.email ? x.email.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.info ? x.info.length : 0))) },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.nama_cluster_cluster ? x.nama_cluster_cluster.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nik_karyawan ? x.nik_karyawan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_karyawan ? x.nama_karyawan.length : 0)),
      ),
    },
  ];
  const multiDataSet = {
    header: [
      "Created",
      "Nama",
      "No KTP",
      "Alamat",
      "RW",
      "RT",
      "No HP",
      "Email",
      "Sumber Info",
      "Nama Cluster",
      "NIK Sales",
      "Nama Sales",
    ],
    heading: [
      {
        created_at: "Created",
        nama: "Nama",
        no_ktp: "No KTP",
        alamat: "Alamat",
        rw: "RW",
        rt: "RT",
        no_hp: "No HP",
        email: "Email",
        info: "Sumber Info",
        nama_cluster: "Nama Cluster",
        nik_karyawan: "NIK Sales",
        nama_karyawan: "Nama Sales",
      },
    ],
    csvHeader: [
      { label: "Created", key: "created_at" },
      { label: "Nama", key: "nama" },
      { label: "No KTP", key: "no_ktp" },
      { label: "Alamat", key: "alamat" },
      { label: "RW", key: "rw" },
      { label: "RT", key: "rt" },
      { label: "No HP", key: "no_hp" },
      { label: "Email", key: "email" },
      { label: "Sumber Info", key: "info" },
      { label: "Nama Cluster", key: "nama_cluster" },
      { label: "NIK Sales", key: "nik_karyawan" },
      { label: "Nama Sales", key: "nama_karyawan" },
    ],
    fileName: "Data_Residential",
    csvFileName: "Data_Residential.csv",
    wscols: wscols,
    csvData: record,
  };
  return multiDataSet;
  //return newBlob;
};

// const formatDataRequest = (
//     request
//   ) => {

//   const survey = request.survey;
//   const instalasi = request.instalasi;
//   const progress = request.progress;
//   const reject = request.reject;
//   const member = request.member;

//   return {
//       request_id : request.request_id,
//       sewa_wifi : request.sewa_wifi,
//       tanggal_request : request.tanggal_request,
//       status : request.status,
//       type : request.type,

//       nik_pic_survey : survey ? (survey.pic ? survey.pic.nik : "") : "",
//       nama_pic_survey : survey ? (survey.pic ? survey.pic.name : "") : "",
//       tgl_instalasi : survey ? survey.tgl_instalasi : "",
//       jadwal_pelaksanaan : survey ? survey.jadwal_pelaksanaan : "",
//       teknikal : survey ? survey.teknikal : "",
//       catatan_teknikal : survey ? survey.catatan_teknikal : "",
//       perijinan : survey ? survey.perijinan : "",
//       catatan_perijinan : survey ? survey.catatan_perijinan : "",
//       kesimpulan : survey ? survey.kesimpulan : "",
//       catatan_lain : survey ? survey.catatan_lain : "",

//       nik_pic_instalasi : instalasi ? (instalasi.pic ? instalasi.pic.nik : "") : "",
//       nama_pic_instalasi : instalasi ? (instalasi.pic ? instalasi.pic.name : "") : "",
//       tgl_mulai_instalasi : instalasi ? instalasi.tgl_selesai : "",
//       perangkat_mynet_terpasang : instalasi ? instalasi.perangkat_mynet_terpasang : "",

//       tgl_selesai_instalasi : progress ? progress.tgl_selesai : "",
//       catatan_reject : reject ? reject.catatan : "",

//       nama_paket : request.paket ? request.paket.nama : "",
//       kapasitas_paket : request.paket ? request.paket.kapasitas : "",
//       harga_paket : request.paket ? request.paket.harga : "",
//       nim_pelanggan : request.pelanggan ? (request.pelanggan.nim ? request.pelanggan.nim : "") : "",
//       nama_pelanggan : request.pelanggan ? request.pelanggan.nama : "",
//       no_ktp_pelanggan : request.pelanggan ? request.pelanggan.no_ktp : "",
//       alamat_pelanggan : request.pelanggan ? request.pelanggan.alamat : "",
//       nama_kost :  request.pelanggan ? (request.pelanggan.kost ? (request.pelanggan.kost.nama ? request.pelanggan.kost.nama : "") : "") : "",
//       alamat_kost : request.pelanggan ? (request.pelanggan.kost ? (request.pelanggan.kost.alamat ? request.pelanggan.kost.alamat : "") : "") : "",
//       no_kamar_pelanggan : request.pelanggan ? (request.pelanggan.no_kamar ? request.pelanggan.no_kamar : "") : "",
//       no_hp_pelanggan : request.pelanggan ? request.pelanggan.no_hp : "",
//       email_pelanggan : request.pelanggan ? request.pelanggan.email : "",
//       info_pelanggan : request.pelanggan ? request.pelanggan.info : "",
//       nama_cluster :  request.type === 'residential' ? (request.pelanggan ? (request.pelanggan.cluster ? (request.pelanggan.cluster.nama_cluster ? request.pelanggan.cluster.nama_cluster : "") : "") : "") : (request.pelanggan ? (request.pelanggan.kost ? (request.pelanggan.kost.cluster ? (request.pelanggan.kost.cluster.nama_cluster ? request.pelanggan.kost.cluster.nama_cluster : "") : "") : "") : ""),
//       keterangan_cluster : request.type === 'residential' ? (request.pelanggan ? (request.pelanggan.cluster ? (request.pelanggan.cluster.keterangan ? request.pelanggan.cluster.keterangan : "") : "" ) : "") : (request.pelanggan ? (request.pelanggan.kost ? (request.pelanggan.kost.cluster ? (request.pelanggan.kost.cluster.nama_cluster ? request.pelanggan.kost.cluster.nama_cluster : "") : "") : "") : ""),
//       nik_sales : request.sales ? (request.sales.nik ? request.sales.nik : "") : "",
//       nama_sales : request.sales ? (request.sales.name ? request.sales.name : "") : "",

//       expiration : member ? (member.expiration ? member.expiration : "") : "",
//   }
// }
const formatDataRequest = (x) => {
  return {
    request_id: x.request_id,
    sewa_wifi: x.sewa_wifi,
    tanggal_request: x.tanggal_request,
    status: x.status_request,
    type: x.type,

    nik_pic_survey: x.nik_pic_survey,
    nama_pic_survey: x.nama_pic_survey,
    tgl_instalasi: x.tgl_instalasi,
    jadwal_pelaksanaan: x.jadwal_pelaksanaan,
    teknikal: x.teknikal,
    catatan_teknikal: x.catatan_teknikal,
    perijinan: x.perijinan,
    catatan_perijinan: x.catatan_perijinan,
    kesimpulan: x.kesimpulan,
    catatan_lain: x.catatan_lain,

    nik_pic_instalasi: x.nik_pic_instalasi,
    nama_pic_instalasi: x.nama_pic_instalasi,
    tgl_mulai_instalasi: x.tgl_mulai_instalasi,
    perangkat_mynet_terpasang: x.perangkat_mynet_terpasang,

    tgl_selesai_instalasi: x.tgl_selesai_instalasi,
    catatan_reject: x.catatan,

    nama_paket: x.nama_paket,
    kapasitas_paket: x.kapasitas,
    harga_paket: x.harga,
    nim_pelanggan: x.nim ? x.nim : "",
    nama_pelanggan: x.nama,
    no_ktp_pelanggan: x.no_ktp,
    alamat_pelanggan: x.alamat ? x.alamat : "",
    nama_kost: x.nama_kost ? x.nama_kost : "",
    alamat_kost: x.alamat_kost ? x.alamat_kost : "",
    no_kamar_pelanggan: x.no_kamar ? x.no_kamar : "",
    no_hp_pelanggan: x.no_hp,
    email_pelanggan: x.email,
    info_pelanggan: x.info,
    nama_cluster: x.nama_cluster ? x.nama_cluster : "",
    keterangan_cluster: x.keterangan_cluster ? x.keterangan_cluster : "",
    nik_sales: x.nik_sales ? x.nik_sales : "",
    nama_sales: x.nama_sales ? x.nama_sales : "",
    expiration: x.expiration ? x.expiration : "",
    username_radius: x.username_radius ? x.username_radius : "",
  };
};

export const convertDataToExcelRequest = (dataRequest) => {
  if (
    dataRequest.length === 0
    //  dataSurvey.length ===
    //  dataInstalasi.length ===
    //  dataProgress.length ===
    //  dataReject.length
  ) {
    return null;
  }
  const record = dataRequest.map((x) => formatDataRequest(x));

  const wscols = [
    {
      wch: Math.max(
        ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.sewa_wifi ? x.sewa_wifi.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.tanggal_request ? x.tanggal_request.length : 0,
        ),
      ),
    },
    { wch: Math.max(...record.map((x) => (x.status ? x.status.length : 0))) },
    { wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))) },

    {
      wch: Math.max(
        ...record.map((x) => (x.nik_pic_survey ? x.nik_pic_survey.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.nama_pic_survey ? x.nama_pic_survey.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.tgl_instalasi ? x.tgl_instalasi.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.jadwal_pelaksanaan ? x.jadwal_pelaksanaan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(...record.map((x) => (x.teknikal ? x.teknikal.length : 0))),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.catatan_teknikal ? x.catatan_teknikal.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.perijinan ? x.perijinan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.catatan_perijinan ? x.catatan_perijinan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.kesimpulan ? x.kesimpulan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.catatan_lain ? x.catatan_lain.length : 0)),
      ),
    },

    {
      wch: Math.max(
        ...record.map((x) =>
          x.nik_pic_instalasi ? x.nik_pic_instalasi.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.nama_pic_instalasi ? x.nama_pic_instalasi.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.tgl_mulai_instalasi ? x.tgl_mulai_instalasi.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.perangkat_mynet_terpasang ? x.perangkat_mynet_terpasang.length : 0,
        ),
      ),
    },

    {
      wch: Math.max(
        ...record.map((x) =>
          x.tgl_selesai_instalasi ? x.tgl_selesai_instalasi.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.catatan_reject ? x.catatan_reject.length : 0)),
      ),
    },

    {
      wch: Math.max(
        ...record.map((x) => (x.nama_paket ? x.nama_paket.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.kapasitas_paket ? x.kapasitas_paket.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.harga_paket ? x.harga_paket.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nim_pelanggan ? x.nim_pelanggan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_pelanggan ? x.nama_pelanggan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.no_ktp_pelanggan ? x.no_ktp_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.alamat_pelanggan ? x.alamat_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.alamat_kost ? x.alamat_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.no_kamar_pelanggan ? x.no_kamar_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.no_hp_pelanggan ? x.no_hp_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.email_pelanggan ? x.email_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.info_pelanggan ? x.info_pelanggan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.keterangan_cluster ? x.keterangan_cluster.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nik_sales ? x.nik_sales.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_sales ? x.nama_sales.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.expiration ? x.expiration.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.username_radius ? x.username_radius.length : 0,
        ),
      ),
    },
  ];
  const multiDataSet = {
    header: [
      "Request ID",
      "Sewa Wifi",
      "Tanggal Request",
      "Status",
      "Type",

      "NIK PIC Survey",
      "Nama PIC Survey",
      "Estimasi Tanggal Instalasi",
      "Jadwal Pelaksanaan Survey",
      "Teknikal",
      "Catatan Teknikal",
      "Perijinan",
      "Catatan Perijinan",
      "Kesimpulan",
      "Catatan Lain",

      "NIK PIC Instalasi",
      "Nama PIC Instalasi",
      "Tanggal Mulai Instalasi",
      "Perangkat Mynet Terpasang",

      "Tanggal Selesai Instalasi",
      "Catatan Reject",

      "Nama Paket",
      "Kapasitas Paket (Mbps)",
      "Harga Paket",
      "NIM Pelanggan",
      "Nama Pelanggan",
      "No KTP Pelanggan",
      "Alamat Pelanggan",
      "Nama Kost",
      "Alamat Kost",
      "No Kamar Pelanggan",
      "No HP Pelanggan",
      "Email Pelanggan",
      "Info Pelanggan",
      "Nama Cluster",
      "Keterangan Cluster",
      "NIK Sales",
      "Nama Sales",
      "Expired Paket",
      "Username",
    ],
    heading: [
      {
        request_id: "Request ID",
        sewa_wifi: "Sewa Wifi",
        tanggal_request: "Tanggal Request",
        status: "Status",
        type: "Type",

        nik_pic_survey: "NIK PIC Survey",
        nama_pic_survey: "Nama PIC Survey",
        tgl_instalasi: "Estimasi Tanggal Instalasi",
        jadwal_pelaksanaan: "Jadwal Pelaksanaan Survey",
        teknikal: "Teknikal",
        catatan_teknikal: "Catatan Teknikal",
        perijinan: "Perijinan",
        catatan_perijinan: "Catatan Perijinan",
        kesimpulan: "Kesimpulan",
        catatan_lain: "Catatan Lain",

        nik_pic_instalasi: "NIK PIC Instalasi",
        nama_pic_instalasi: "Nama PIC Instalasi",
        tgl_mulai_instalasi: "Tanggal Mulai Instalasi",
        perangkat_mynet_terpasang: "Perangkat Mynet Terpasang",

        tgl_selesai_instalasi: "Tanggal Selesai Instalasi",
        catatan_reject: "Catatan Reject",

        nama_paket: "Nama Paket",
        kapasitas_paket: "Kapasitas Paket (Mbps)",
        harga_paket: "Harga Paket",
        nim_pelanggan: "NIM Pelanggan",
        nama_pelanggan: "Nama Pelanggan",
        no_ktp_pelanggan: "No KTP Pelanggan",
        alamat_pelanggan: "Alamat Pelanggan",
        nama_kost: "Nama Kost",
        alamat_kost: "Alamat Kost",
        no_kamar_pelanggan: "No Kamar Pelanggan",
        no_hp_pelanggan: "No HP Pelanggan",
        email_pelanggan: "Email Pelanggan",
        info_pelanggan: "Info Pelanggan",
        nama_cluster: "Nama Cluster",
        keterangan_cluster: "Keterangan Cluster",
        nik_sales: "NIK Sales",
        nama_sales: "Nama Sales",
        expiration: "Expired Paket",
        username_radius: "Username",
      },
    ],
    csvHeader: [
      { label: "Request ID", key: "request_id" },
      { label: "Sewa Wifi", key: "sewa_wifi" },
      { label: "Tanggal Request", key: "tanggal_request" },
      { label: "Status", key: "status" },
      { label: "Type", key: "type" },

      { label: "NIK PIC Survey", key: "nik_pic_survey" },
      { label: "Nama PIC Survey", key: "nama_pic_survey" },
      { label: "Estimasi Tanggal Instalasi", key: "tgl_instalasi" },
      { label: "Jadwal Pelaksanaan Survey", key: "jadwal_pelaksanaan" },
      { label: "Teknikal", key: "teknikal" },
      { label: "Catatan Teknikal", key: "catatan_teknikal" },
      { label: "Perijinan", key: "perijinan" },
      { label: "Catatan Perijinan", key: "catatan_perijinan" },
      { label: "Kesimpulan", key: "kesimpulan" },
      { label: "Catatan Lain", key: "catatan_lain" },

      { label: "NIK PIC Instalasi", key: "nik_pic_instalasi" },
      { label: "Nama PIC Instalasi", key: "nama_pic_instalasi" },
      { label: "Tanggal Mulai Instalasi", key: "tgl_mulai_instalasi" },
      { label: "Perangkat Mynet Terpasang", key: "perangkat_mynet_terpasang" },

      { label: "Tanggal Selesai Instalasi", key: "tgl_selesai_instalasi" },
      { label: "Catatan Reject", key: "catatan_reject" },

      { label: "Nama Paket", key: "nama_paket" },
      { label: "Kapasitas Paket (Mbps)", key: "kapasitas_paket" },
      { label: "Harga Paket", key: "harga_paket" },
      { label: "NIM Pelanggan", key: "nim_pelanggan" },
      { label: "Nama Pelanggan", key: "nama_pelanggan" },
      { label: "No KTP Pelanggan", key: "no_ktp_pelanggan" },
      { label: "Alamat Pelanggan", key: "alamat_pelanggan" },
      { label: "Nama Kost", key: "nama_kost" },
      { label: "Alamat Kost", key: "alamat_kost" },
      { label: "No Kamar Pelanggan", key: "no_kamar_pelanggan" },
      { label: "No HP Pelanggan", key: "no_hp_pelanggan" },
      { label: "Email Pelanggan", key: "email_pelanggan" },
      { label: "Info Pelanggan", key: "info_pelanggan" },
      { label: "Nama Cluster", key: "nama_cluster" },
      { label: "Keterangan Cluster", key: "keterangan_cluster" },
      { label: "NIK Sales", key: "nik_sales" },
      { label: "Nama Sales", key: "nama_sales" },
      { label: "Expired Paket", key: "expiration" },
      { label: "Username", key: "username_radius" },
    ],
    fileName: "Data_FAB",
    csvFileName: "Data_FAB.csv",
    wscols: wscols,
    csvData: record,
  };
  return multiDataSet;
  //return newBlob;
};

const formatDataSurvey = (x) => {
  return {
    request_id: x.request_id,
    status_survey: x.status_request,

    nik_pic_survey: x.nik_pic_survey,
    nama_pic_survey: x.nama_pic_survey,
    tgl_instalasi: x.tgl_instalasi,
    jadwal_pelaksanaan: x.jadwal_pelaksanaan,
    teknikal: x.teknikal,
    catatan_teknikal: x.catatan_teknikal,
    perijinan: x.perijinan,
    catatan_perijinan: x.catatan_perijinan,
    kesimpulan: x.kesimpulan,
    catatan_lain: x.catatan_lain,

    // nama_paket : request.paket ? request.paket.nama : "",
    // kapasitas_paket : request.paket ? request.paket.kapasitas : "",
    // harga_paket : request.paket ? request.paket.harga : "",
    nim_pelanggan: x.nim,
    nama_pelanggan: x.nama,
    no_ktp_pelanggan: x.no_ktp,
    alamat_pelanggan: x.alamat,
    nama_kost: x.nama_kost,
    alamat_kost: x.alamat_kost,
    no_kamar_pelanggan: x.no_kamar,
    no_hp_pelanggan: x.no_hp,
    email_pelanggan: x.email,
    info_pelanggan: x.info,
    nama_cluster: x.nama_cluster,
    keterangan_cluster: x.keterangan_cluster,
    nik_sales: x.nik_sales,
    nama_sales: x.nama_sales,
  };
};

export const convertDataToExcelSurvey = (data) => {
  if (data.length <= 0) {
    return null;
  }

  const record = data.map((x) => formatDataSurvey(x));
  const wscols = [
    {
      wch: Math.max(
        ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
      ),
    },
    { wch: Math.max(...record.map((x) => (x.nik_pic ? x.nik_pic.length : 0))) },
    {
      wch: Math.max(...record.map((x) => (x.nama_pic ? x.nama_pic.length : 0))),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.tgl_instalasi ? x.tgl_instalasi.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.status_survey ? x.status_survey.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.jadwal_pelaksanaan ? x.jadwal_pelaksanaan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(...record.map((x) => (x.teknikal ? x.teknikal.length : 0))),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.catatan_teknikal ? x.catatan_teknikal.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.perijinan ? x.perijinan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.catatan_perijinan ? x.catatan_perijinan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.kesimpulan ? x.kesimpulan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.catatan_lain ? x.catatan_lain.length : 0)),
      ),
    },

    {
      wch: Math.max(
        ...record.map((x) => (x.nim_pelanggan ? x.nim_pelanggan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_pelanggan ? x.nama_pelanggan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.no_ktp_pelanggan ? x.no_ktp_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.alamat_pelanggan ? x.alamat_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.alamat_kost ? x.alamat_kost.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.no_kamar_pelanggan ? x.no_kamar_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.no_hp_pelanggan ? x.no_hp_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.email_pelanggan ? x.email_pelanggan.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.info_pelanggan ? x.info_pelanggan.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) =>
          x.keterangan_cluster ? x.keterangan_cluster.length : 0,
        ),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nik_sales ? x.nik_sales.length : 0)),
      ),
    },
    {
      wch: Math.max(
        ...record.map((x) => (x.nama_sales ? x.nama_sales.length : 0)),
      ),
    },
  ];
  const multiDataSet = {
    header: [
      "Request ID",
      "NIK PIC",
      "Nama PIC",
      "Estimasi Tanggal Instalasi",
      "Status Survey",
      "Jadwal Pelaksanaan",
      "Teknikal",
      "Catatan Teknikal",
      "Perijinan",
      "Catatan Perijinan",
      "Kesimpulan",
      "Catatan Lain",
      "NIM Pelanggan",
      "Nama Pelanggan",
      "No KTP Pelanggan",
      "Alamat Pelanggan",
      "Nama Kost",
      "Alamat Kost",
      "No Kamar Pelanggan",
      "No HP Pelanggan",
      "Email Pelanggan",
      "Info Pelanggan",
      "Nama Cluster",
      "Keterangan Cluster",
      "NIK Sales",
      "Nama Sales",
    ],
    heading: [
      {
        request_id: "Request ID",
        nik_pic: "NIK PIC",
        nama_pic: "Nama PIC",
        tgl_instalasi: "Estimasi Tanggal Instalasi",
        status_survey: "Status Survey",
        jadwal_pelaksanaan: "Jadwal Pelaksanaan",
        teknikal: "Teknikal",
        catatan_teknikal: "Catatan Teknikal",
        perijinan: "Perijinan",
        catatan_perijinan: "Catatan Perijinan",
        kesimpulan: "Kesimpulan",
        catatan_lain: "Catatan Lain",
        nim_pelanggan: "NIM Pelanggan",
        nama_pelanggan: "Nama Pelanggan",
        no_ktp_pelanggan: "No KTP Pelanggan",
        alamat_pelanggan: "Alamat Pelanggan",
        nama_kost: "Nama Kost",
        alamat_kost: "Alamat Kost",
        no_kamar_pelanggan: "No Kamar Pelanggan",
        no_hp_pelanggan: "No HP Pelanggan",
        email_pelanggan: "Email Pelanggan",
        info_pelanggan: "Info Pelanggan",
        nama_cluster: "Nama Cluster",
        keterangan_cluster: "Keterangan Cluster",
        nik_sales: "NIK Sales",
        nama_sales: "Nama Sales",
      },
    ],
    csvHeader: [
      { label: "Request ID", key: "request_id" },
      { label: "NIK PIC", key: "nik_pic" },
      { label: "Nama PIC", key: "nama_pic" },
      { label: "Estimasi Tanggal Instalasi", key: "tgl_instalasi" },
      { label: "Status Survey", key: "status_survey" },
      { label: "Jadwal Pelaksanaan", key: "jadwal_pelaksanaan" },
      { label: "Teknikal", key: "teknikal" },
      { label: "Catatan Teknikal", key: "catatan_teknikal" },
      { label: "Perijinan", key: "perijinan" },
      { label: "Catatan Perijinan", key: "catatan_perijinan" },
      { label: "Kesimpulan", key: "kesimpulan" },
      { label: "Catatan Lain", key: "catatan_lain" },
      { label: "NIM Pelanggan", key: "nim_pelanggan" },
      { label: "Nama Pelanggan", key: "nama_pelanggan" },
      { label: "No KTP Pelanggan", key: "no_ktp_pelanggan" },
      { label: "Alamat Pelanggan", key: "alamat_pelanggan" },
      { label: "Nama Kost", key: "nama_kost" },
      { label: "Alamat Kost", key: "alamat_kost" },
      { label: "No Kamar Pelanggan", key: "no_kamar_pelanggan" },
      { label: "No HP Pelanggan", key: "no_hp_pelanggan" },
      { label: "Email Pelanggan", key: "email_pelanggan" },
      { label: "Info Pelanggan", key: "info_pelanggan" },
      { label: "Nama Cluster", key: "nama_cluster" },
      { label: "Keterangan Cluster", key: "keterangan_cluster" },
      { label: "NIK Sales", key: "nik_sales" },
      { label: "Nama Sales", key: "nama_sales" },
    ],
    fileName: "Data_Survey",
    csvFileName: "Data_Survey.csv",
    wscols: wscols,
    csvData: record,
  };
  return multiDataSet;
  //return newBlob;
};

const formatDataInstalasi = (x) => {
  return {
    request_id: x.request_id,
    status_instalasi: x.status_request,

    nik_pic: x.nik_pic_instalasi,
    nama_pic: x.nama_pic_instalasi,
    tgl_selesai: x.tgl_mulai_instalasi,
    perangkat_mynet_terpasang: x.perangkat_mynet_terpasang,

    type: x.type,
    nim_pelanggan: x.nim,
    nama_pelanggan: x.nama,
    no_ktp_pelanggan: x.no_ktp,
    alamat_pelanggan: x.alamat,
    nama_kost: x.nama_kost,
    alamat_kost: x.alamat_kost,
    no_kamar_pelanggan: x.no_kamar,
    no_hp_pelanggan: x.no_hp,
    email_pelanggan: x.email,
    info_pelanggan: x.info,
    nama_cluster: x.nama_cluster,
    keterangan_cluster: x.keterangan_cluster,
    nik_sales: x.nik_sales,
    nama_sales: x.nama_sales,
  };
};

export const convertDataToExcelInstalasi = (dataInstalasi) => {
  if (dataInstalasi.length > 0) {
    const record = dataInstalasi.map((x) => formatDataInstalasi(x));
    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.nik_pic ? x.nik_pic.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_pic ? x.nama_pic.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_instalasi ? x.status_instalasi.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.tgl_selesai ? x.tgl_selesai.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.perangkat_mynet_terpasang
              ? x.perangkat_mynet_terpasang.length
              : 0,
          ),
        ),
      },

      {
        wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nim_pelanggan ? x.nim_pelanggan.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nama_pelanggan ? x.nama_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_ktp_pelanggan ? x.no_ktp_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.alamat_pelanggan ? x.alamat_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.alamat_kost ? x.alamat_kost.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_kamar_pelanggan ? x.no_kamar_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_hp_pelanggan ? x.no_hp_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.email_pelanggan ? x.email_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.info_pelanggan ? x.info_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.keterangan_cluster ? x.keterangan_cluster.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nik_sales ? x.nik_sales.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_sales ? x.nama_sales.length : 0)),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Request ID",
        "NIK PIC",
        "Nama PIC",
        "Status Instalasi",
        "Tanggal Selesai",
        "Perangkat Mynet Terpasang",
        "Type Pelanggan",
        "NIM Pelanggan",
        "Nama Pelanggan",
        "No KTP Pelanggan",
        "Alamat Pelanggan",
        "Nama Kost",
        "Alamat Kost",
        "No Kamar Pelanggan",
        "No HP Pelanggan",
        "Email Pelanggan",
        "Info Pelanggan",
        "Nama Cluster",
        "Keterangan Cluster",
        "NIK Sales",
        "Nama Sales",
      ],
      heading: [
        {
          request_id: "Request ID",
          nik_pic: "NIK PIC",
          nama_pic: "Nama PIC",
          status_instalasi: "Status Instalasi",
          tgl_selesai: "Tanggal Selesai",
          perangkat_mynet_terpasang: "Perangkat Mynet Terpasang",
          type: "Type Pelanggan",
          nim_pelanggan: "NIM Pelanggan",
          nama_pelanggan: "Nama Pelanggan",
          no_ktp_pelanggan: "No KTP Pelanggan",
          alamat_pelanggan: "Alamat Pelanggan",
          nama_kost: "Nama Kost",
          alamat_kost: "Alamat Kost",
          no_kamar_pelanggan: "No Kamar Pelanggan",
          no_hp_pelanggan: "No HP Pelanggan",
          email_pelanggan: "Email Pelanggan",
          info_pelanggan: "Info Pelanggan",
          nama_cluster: "Nama Cluster",
          keterangan_cluster: "Keterangan Cluster",
          nik_sales: "NIK Sales",
          nama_sales: "Nama Sales",
        },
      ],
      csvHeader: [
        { label: "Request ID", key: "request_id" },
        { label: "NIK PIC", key: "nik_pic" },
        { label: "Nama PIC", key: "nama_pic" },
        { label: "Status Instalasi", key: "status_instalasi" },
        { label: "Tanggal Selesai", key: "tgl_selesai" },
        {
          label: "Perangkat Mynet Terpasang",
          key: "perangkat_mynet_terpasang",
        },
        { label: "Type Pelanggan", key: "type" },
        { label: "NIM Pelanggan", key: "nim_pelanggan" },
        { label: "Nama Pelanggan", key: "nama_pelanggan" },
        { label: "No KTP Pelanggan", key: "no_ktp_pelanggan" },
        { label: "Alamat Pelanggan", key: "alamat_pelanggan" },
        { label: "Nama Kost", key: "nama_kost" },
        { label: "Alamat Kost", key: "alamat_kost" },
        { label: "No Kamar Pelanggan", key: "no_kamar_pelanggan" },
        { label: "No HP Pelanggan", key: "no_hp_pelanggan" },
        { label: "Email Pelanggan", key: "email_pelanggan" },
        { label: "Info Pelanggan", key: "info_pelanggan" },
        { label: "Nama Cluster", key: "nama_cluster" },
        { label: "Keterangan Cluster", key: "keterangan_cluster" },
        { label: "NIK Sales", key: "nik_sales" },
        { label: "Nama Sales", key: "nama_sales" },
      ],
      fileName: "Data_SPK_Instalasi",
      csvFileName: "Data_SPK_Instalasi.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataProgress = (x) => {
  return {
    request_id: x.request_id,
    status_progress: x.status_request,

    // nik_pic : x ? (x.pic ? x.pic.nik : "") : "",
    // nama_pic : x ? (x.pic ? x.pic.name : "") : "",
    tgl_selesai: x.tgl_mulai_instalasi,

    type: x.type,
    nim_pelanggan: x.nim,
    nama_pelanggan: x.nama,
    no_ktp_pelanggan: x.no_ktp,
    alamat_pelanggan: x.alamat,
    rw_pelanggan: x.rw,
    rt_pelanggan: x.rt,
    nama_kost: x.nama_kost,
    status_kemitraan: x.status_kemitraan,
    alamat_kost: x.alamat_kost,
    no_kamar_pelanggan: x.no_kamar,
    no_hp_pelanggan: x.no_hp,
    email_pelanggan: x.email,
    info_pelanggan: x.info,
    nama_cluster: x.nama_cluster,
    keterangan_cluster: x.keterangan_cluster,
    nik_sales: x.nik_sales,
    nama_sales: x.nama_sales,

    expiration: x.expiration,
    harga: x.harga,
    username_radius: x.username_radius,
  };
};

export const convertDataToExcelProgress = (dataProgress) => {
  if (dataProgress.length > 0) {
    const record = dataProgress.map((x) => formatDataProgress(x));
    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
        ),
      },
      // { wch: Math.max(...record.map(x => x.nik_pic ? x.nik_pic.length : 0 )) },
      // { wch: Math.max(...record.map(x => x.nama_pic ? x.nama_pic.length : 0 )) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_progress ? x.status_progress.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.tgl_selesai ? x.tgl_selesai.length : 0)),
        ),
      },

      {
        wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nim_pelanggan ? x.nim_pelanggan.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nama_pelanggan ? x.nama_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_ktp_pelanggan ? x.no_ktp_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.alamat_pelanggan ? x.alamat_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.rw_pelanggan ? x.rw_pelanggan.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.rt_pelanggan ? x.rt_pelanggan.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_kemitraan ? x.status_kemitraan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.alamat_kost ? x.alamat_kost.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_kamar_pelanggan ? x.no_kamar_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_hp_pelanggan ? x.no_hp_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.email_pelanggan ? x.email_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.info_pelanggan ? x.info_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.keterangan_cluster ? x.keterangan_cluster.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nik_sales ? x.nik_sales.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_sales ? x.nama_sales.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.expiration ? x.expiration.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.harga ? x.harga.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.username_radius ? x.username_radius.length : 0,
          ),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Request ID",
        // "NIK PIC",
        // "Nama PIC",
        "Status Progress",
        "Tanggal Selesai",
        "Type Pelanggan",
        "NIM Pelanggan",
        "Nama Pelanggan",
        "No KTP Pelanggan",
        "Alamat Pelanggan",
        "RW",
        "RT",
        "Nama Kost",
        "Kemitraan",
        "Alamat Kost",
        "No Kamar Pelanggan",
        "No HP Pelanggan",
        "Email Pelanggan",
        "Info Pelanggan",
        "Nama Cluster",
        "Keterangan Cluster",
        "NIK Sales",
        "Nama Sales",
        "Expiration Paket",
        "Harga",
        "Username",
      ],
      heading: [
        {
          request_id: "Request ID",
          // nik_pic : "NIK PIC",
          // nama_pic : "Nama PIC",
          status_progress: "Status Progress",
          tgl_selesai: "Tanggal Selesai",
          type: "Type Pelanggan",
          nim_pelanggan: "NIM Pelanggan",
          nama_pelanggan: "Nama Pelanggan",
          no_ktp_pelanggan: "No KTP Pelanggan",
          alamat_pelanggan: "Alamat Pelanggan",
          rw_pelanggan: "RW",
          rt_pelanggan: "RT",
          nama_kost: "Nama Kost",
          status_kemitraan: "Kemitraan",
          alamat_kost: "Alamat Kost",
          no_kamar_pelanggan: "No Kamar Pelanggan",
          no_hp_pelanggan: "No HP Pelanggan",
          email_pelanggan: "Email Pelanggan",
          info_pelanggan: "Info Pelanggan",
          nama_cluster: "Nama Cluster",
          keterangan_cluster: "Keterangan Cluster",
          nik_sales: "NIK Sales",
          nama_sales: "Nama Sales",
          expiration: "Expiration Paket",
          harga: "Harga",
          username_radius: "Username",
        },
      ],
      csvHeader: [
        { label: "Request ID", key: "request_id" },
        // {label : "NIK PIC", key : "nik_pic"},
        // {label : "Nama PIC", key : "nama_pic"},
        { label: "Status Progress", key: "status_progress" },
        { label: "Tanggal Selesai", key: "tgl_selesai" },
        { label: "Type Pelanggan", key: "type" },
        { label: "NIM Pelanggan", key: "nim_pelanggan" },
        { label: "Nama Pelanggan", key: "nama_pelanggan" },
        { label: "No KTP Pelanggan", key: "no_ktp_pelanggan" },
        { label: "Alamat Pelanggan", key: "alamat_pelanggan" },
        { label: "RW", key: "rw_pelanggan" },
        { label: "RT", key: "rt_pelanggan" },
        { label: "Nama Kost", key: "nama_kost" },
        { label: "Kemitraan", key: "status_kemitraan" },
        { label: "Alamat Kost", key: "alamat_kost" },
        { label: "No Kamar Pelanggan", key: "no_kamar_pelanggan" },
        { label: "No HP Pelanggan", key: "no_hp_pelanggan" },
        { label: "Email Pelanggan", key: "email_pelanggan" },
        { label: "Info Pelanggan", key: "info_pelanggan" },
        { label: "Nama Cluster", key: "nama_cluster" },
        { label: "Keterangan Cluster", key: "keterangan_cluster" },
        { label: "NIK Sales", key: "nik_sales" },
        { label: "Nama Sales", key: "nama_sales" },
        { label: "Expiration Paket", key: "expiration" },
        { label: "Harga", key: "harga" },
        { label: "Username", key: "username_radius" },
      ],
      fileName: "Data_Laporan_Instalasi",
      csvFileName: "Data_Laporan_Instalasi.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataReject = (x) => {
  return {
    request_id: x.request_id,
    catatan: x.catatan ? x.catatan : "",
    status_reject: x.status_request,

    type: x.type,
    nim_pelanggan: x.nim ? x.nim : "",
    nama_pelanggan: x.nama,
    no_ktp_pelanggan: x.no_ktp,
    alamat_pelanggan: x.alamat ? x.alamat : "",
    nama_kost: x.nama_kost ? x.nama_kost : "",
    alamat_kost: x.alamat_kost ? x.alamat_kost : "",
    no_kamar_pelanggan: x.no_kamar ? x.no_kamar : "",
    no_hp_pelanggan: x.no_hp,
    email_pelanggan: x.email,
    info_pelanggan: x.info,
    nama_cluster: x.nama_cluster ? x.nama_cluster : "",
    keterangan_cluster: x.keterangan_cluster ? x.keterangan_cluster : "",
    nik_sales: x.nik_sales ? x.nik_sales : "",
    nama_sales: x.nama_sales ? x.nama_sales : "",
  };
};

export const convertDataToExcelReject = (dataReject) => {
  if (dataReject.length > 0) {
    const record = dataReject.map((x) => formatDataReject(x));
    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.catatan ? x.catatan.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.status_reject ? x.status_reject.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))) },

      {
        wch: Math.max(
          ...record.map((x) => (x.nim_pelanggan ? x.nim_pelanggan.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nama_pelanggan ? x.nama_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_ktp_pelanggan ? x.no_ktp_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.alamat_pelanggan ? x.alamat_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.alamat_kost ? x.alamat_kost.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_kamar_pelanggan ? x.no_kamar_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.no_hp_pelanggan ? x.no_hp_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.email_pelanggan ? x.email_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.info_pelanggan ? x.info_pelanggan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.keterangan_cluster ? x.keterangan_cluster.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nik_sales ? x.nik_sales.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_sales ? x.nama_sales.length : 0)),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Request ID",
        "Catatan",
        "Status Reject",
        "Type",
        "NIM Pelanggan",
        "Nama Pelanggan",
        "No KTP Pelanggan",
        "Alamat Pelanggan",
        "Nama Kost",
        "Alamat Kost",
        "No Kamar Pelanggan",
        "No HP Pelanggan",
        "Email Pelanggan",
        "Info Pelanggan",
        "Nama Cluster",
        "Keterangan Cluster",
        "NIK Sales",
        "Nama Sales",
      ],
      heading: [
        {
          request_id: "Request ID",
          catatan: "Catatan",
          status_reject: "Status Reject",
          type: "Type",
          nim_pelanggan: "NIM Pelanggan",
          nama_pelanggan: "Nama Pelanggan",
          no_ktp_pelanggan: "No KTP Pelanggan",
          alamat_pelanggan: "Alamat Pelanggan",
          nama_kost: "Nama Kost",
          alamat_kost: "Alamat Kost",
          no_kamar_pelanggan: "No Kamar Pelanggan",
          no_hp_pelanggan: "No HP Pelanggan",
          email_pelanggan: "Email Pelanggan",
          info_pelanggan: "Info Pelanggan",
          nama_cluster: "Nama Cluster",
          keterangan_cluster: "Keterangan Cluster",
          nik_sales: "NIK Sales",
          nama_sales: "Nama Sales",
        },
      ],
      csvHeader: [
        { label: "Request ID", key: "request_id" },
        { label: "Catatan", key: "catatan" },
        { label: "Status Reject", key: "status_reject" },
        { label: "Type", key: "type" },
        { label: "NIM Pelanggan", key: "nim_pelanggan" },
        { label: "Nama Pelanggan", key: "nama_pelanggan" },
        { label: "No KTP Pelanggan", key: "no_ktp_pelanggan" },
        { label: "Alamat Pelanggan", key: "alamat_pelanggan" },
        { label: "Nama Kost", key: "nama_kost" },
        { label: "Alamat Kost", key: "alamat_kost" },
        { label: "No Kamar Pelanggan", key: "no_kamar_pelanggan" },
        { label: "No HP Pelanggan", key: "no_hp_pelanggan" },
        { label: "Email Pelanggan", key: "email_pelanggan" },
        { label: "Info Pelanggan", key: "info_pelanggan" },
        { label: "Nama Cluster", key: "nama_cluster" },
        { label: "Keterangan Cluster", key: "keterangan_cluster" },
        { label: "NIK Sales", key: "nik_sales" },
        { label: "Nama Sales", key: "nama_sales" },
      ],
      fileName: "Data_Reject",
      csvFileName: "Data_Reject.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataInvoice = (x) => {
  return {
    invnum: x.invnum,
    typeinvoice: x.typeinvoice,
    created_by: x.creator,
    created_at: x.created_at,
    service: x.nama_packet,
    username: x.username_radius,

    paymode: x.payment_type_name,
    bank: x.bank_name,
    rekening: x.bank_account_number,
    price: x.price,
    nama: x.request_info ? x.request_info.nama : "",
    type: x.request_info ? x.request_info.type : "",
    reseller: x.reseller_name,
    keterangan: x.comment,

    kost: x.request_info ? x.request_info.nama_kost : "",
    status_kemitraan: x.status_kemitraan ?? "",
    alamat: x.request_info ? x.request_info.alamat : "",
    nama_cluster: x.request_info ? x.request_info.nama_cluster : "",
  };
};

export const convertDataToExcelInvoice = (dataInvoice) => {
  if (dataInvoice.length > 0) {
    const record = dataInvoice.map((x) => formatDataInvoice(x));
    console.log(record);
    const wscols = [
      { wch: Math.max(...record.map((x) => (x.invnum ? x.invnum.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.typeinvoice ? x.typeinvoice.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.creator ? x.creator.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.created_at ? x.created_at.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.paketnama ? x.paketnama.length : 0)),
        ),
      },

      {
        wch: Math.max(
          ...record.map((x) => (x.username ? x.username.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.paymenttype ? x.paymenttype.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.bank ? x.bank.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.rekening ? x.rekening.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.price ? x.price.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.reseller ? x.reseller.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.comment ? x.comment.length : 0))),
      },

      { wch: Math.max(...record.map((x) => (x.kost ? x.kost.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_kemitraan ? x.status_kemitraan.length : 0,
          ),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Invoice Number",
        "Invoice Type",
        "Created By",
        "Created At",
        "Service",
        "Username",
        "Payment Mode",
        "Bank Tujuan",
        "No Rekening",
        "Price",
        "Nama Pelanggan",
        "Pelanggan Type",
        "Reseller",
        "Description",
        "Kost",
        "Kemitraan",
        "Alamat",
        "Nama Cluster",
      ],
      heading: [
        {
          invnum: "Invoice Number",
          typeinvoice: "Invoice Type",
          created_by: "Created By",
          created_at: "Created At",
          service: "Service",
          username: "Username",
          paymode: "Payment Mode",
          bank: "Bank Tujuan",
          rekening: "No Rekening",
          price: "Price",
          nama: "Nama Pelanggan",
          type: "Pelanggan Type",
          reseller: "Reseller",
          keterangan: "Description",
          kost: "Kost",
          status_kemitraan: "Kemitraan",
          alamat: "Alamat",
          nama_cluster: "Nama Cluster",
        },
      ],
      csvHeader: [
        { label: "Invoice Number", key: "invnum" },
        { label: "Invoice Type", key: "typeinvoice" },
        { label: "Created By", key: "created_by" },
        { label: "Created At", key: "created_at" },
        { label: "Service", key: "service" },
        { label: "Username", key: "username" },
        { label: "Payment Mode", key: "paymode" },
        { label: "Bank Tujuan", key: "bank" },
        { label: "No Rekening", key: "rekening" },
        { label: "Price", key: "price" },
        { label: "Nama Pelanggan", key: "nama" },
        { label: "Pelanggan Type", key: "type" },
        { label: "Reseller", key: "reseller" },
        { label: "Description", key: "keterangan" },
        { label: "Kost", key: "kost" },
        { label: "Kemitraan", key: "status_kemitraan" },
        { label: "Alamat", key: "alamat" },
        { label: "Nama Cluster", key: "nama_cluster" },
      ],
      fileName: "Data_Invoice",
      csvFileName: "Data_Invoice.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataRecovery = (x) => {
  return {
    invnum: x.invoice_info?.invnum ?? "",
    typeinvoice: x.invoice_info?.typeinvoice ?? "",
    created_by: x.creator,
    created_at: x.created_at,
    service: x.invoice_info?.nama_packet ?? "",
    username: x.invoice_info?.username_radius ?? "",

    paymode: x.invoice_info?.payment_type_name ?? "",
    bank: x.invoice_info?.bank_name ?? "",
    rekening: x.invoice_info?.bank_account_number ?? "",
    price_after: x.price_after,
    nama: x.request_info ? x.request_info.nama : "",
    type: x.request_info ? x.request_info.type : "",
    reseller: x.invoice_info?.reseller_name ?? "",
    keterangan: x.invoice_info?.comment ?? "",

    kost: x.request_info ? x.request_info.nama_kost : "",
    status_kemitraan: x.invoice_info?.status_kemitraan ?? "",
    alamat: x.request_info ? x.request_info.alamat : "",
    nama_cluster: x.request_info ? x.request_info.nama_cluster : "",

    reason: x.reason,
    invnum_recovery: x?.invoice_recovery_info?.invnum ?? "",
    price_recovery: x.price_recovery,
    selisih_harga: x.selisih_harga,
    expiration_recovery: x.expiration_recovery,
    status: x.status,
  };
};

export const convertDataToExcelRecovery = (dataRecovery) => {
  if (dataRecovery.length > 0) {
    const record = dataRecovery.map((x) => formatDataRecovery(x));

    const wscols = [
      { wch: Math.max(...record.map((x) => (x.invnum ? x.invnum.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.typeinvoice ? x.typeinvoice.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.creator ? x.creator.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.created_at ? x.created_at.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.paketnama ? x.paketnama.length : 0)),
        ),
      },

      {
        wch: Math.max(
          ...record.map((x) => (x.username ? x.username.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.paymenttype ? x.paymenttype.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.bank ? x.bank.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.rekening ? x.rekening.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.price ? x.price.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.reseller ? x.reseller.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.comment ? x.comment.length : 0))),
      },

      { wch: Math.max(...record.map((x) => (x.kost ? x.kost.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_kemitraan ? x.status_kemitraan.length : 0,
          ),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.reason ? x.reason.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.invnum_recovery ? x.invnum_recovery.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.price_recovery ? x.price_recovery.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.selisih_harga ? x.selisih_harga.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.expiration_recovery ? x.expiration_recovery.length : 0,
          ),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.status ? x.status.length : 0))) },
    ];
    const multiDataSet = {
      header: [
        "Invoice Number",
        "Invoice Type",
        "Created By",
        "Created At",
        "Service",
        "Username",
        "Payment Mode",
        "Bank Tujuan",
        "No Rekening",
        "Price",
        "Nama Pelanggan",
        "Pelanggan Type",
        "Reseller",
        "Description",
        "Kost",
        "Kemitraan",
        "Alamat",
        "Nama Cluster",
        "Alasan Revisi",
        "No Invoice Revisi",
        "Harga Revisi",
        "Harga Invoice",
        "Expiration Revisi",
        "Status Revisi",
      ],
      heading: [
        {
          invnum: "Invoice Number",
          typeinvoice: "Invoice Type",
          created_by: "Created By",
          created_at: "Created At",
          service: "Service",
          username: "Username",
          paymode: "Payment Mode",
          bank: "Bank Tujuan",
          rekening: "No Rekening",
          price: "Price",
          nama: "Nama Pelanggan",
          type: "Pelanggan Type",
          reseller: "Reseller",
          keterangan: "Description",
          kost: "Kost",
          status_kemitraan: "Kemitraan",
          alamat: "Alamat",
          nama_cluster: "Nama Cluster",
          reason: "Alasan Revisi",
          invnum_recovery: "No Invoice Revisi",
          price_recovery: "Harga Revisi",
          selisih_harga: "Harga Invoice",
          expiration_recovery: "Expiration Revisi",
          status: "Status Revisi",
        },
      ],
      csvHeader: [
        { label: "Invoice Number", key: "invnum" },
        { label: "Invoice Type", key: "typeinvoice" },
        { label: "Created By", key: "created_by" },
        { label: "Created At", key: "created_at" },
        { label: "Service", key: "service" },
        { label: "Username", key: "username" },
        { label: "Payment Mode", key: "paymode" },
        { label: "Bank Tujuan", key: "bank" },
        { label: "No Rekening", key: "rekening" },
        { label: "Price", key: "price" },
        { label: "Nama Pelanggan", key: "nama" },
        { label: "Pelanggan Type", key: "type" },
        { label: "Reseller", key: "reseller" },
        { label: "Description", key: "keterangan" },
        { label: "Kost", key: "kost" },
        { label: "Kemitraan", key: "status_kemitraan" },
        { label: "Alamat", key: "alamat" },
        { label: "Nama Cluster", key: "nama_cluster" },
        { label: "Alasan Revisi", key: "reason" },
        { label: "No Invoice Revisi", key: "invnum_recovery" },
        { label: "Harga Revisi", key: "price_recovery" },
        { label: "Harga Invoice", key: "selisih_harga" },
        { label: "Expiration Revisi", key: "expiration_recovery" },
        { label: "Status Revisi", key: "status" },
      ],
      fileName: "Data_Recovery",
      csvFileName: "Data_Recovery.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataInvoiceSummary = (x) => {
  return {
    no: x.no,
    tanggal: x.tanggal,
    jlh_mahasiswa: x.jlh_mahasiswa,
    nom_mahasiswa: x.nom_mahasiswa,
    jlh_residential: x.jlh_residential,
    nom_residential: x.nom_residential,
    jlh_corporate: x.jlh_corporate,
    nom_corporate: x.nom_corporate,
    total: x.total,
  };
};

export const convertDataToExcelInvoiceSummary = (dataInvoice) => {
  if (dataInvoice.length > 0) {
    const record = dataInvoice.map((x) => formatDataInvoiceSummary(x));

    const wscols = [
      { wch: Math.max(...record.map((x) => (x.no ? x.no.length : 0))) },
      {
        wch: Math.max(...record.map((x) => (x.tanggal ? x.tanggal.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.jlh_mahasiswa ? x.jlh_mahasiswa.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nom_mahasiswa ? x.nom_mahasiswa.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.jlh_residential ? x.jlh_residential.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nom_residential ? x.nom_residential.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.jlh_corporate ? x.jlh_corporate.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nom_corporate ? x.nom_corporate.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.total ? x.total.length : 0))) },
    ];
    const multiDataSet = {
      header: [
        "No",
        "Tanggal",
        "Jumlah Mahasiswa",
        "Nominal Mahasiswa",
        "Jumlah Residential",
        "Nominal Residential",
        "Jumlah Corporate",
        "Nominal Corporate",
        "Total",
      ],
      heading: [
        {
          no: "No",
          tanggal: "Tanggal",
          jlh_mahasiswa: "Jumlah Mahasiswa",
          nom_mahasiswa: "Nominal Mahasiswa",
          jlh_residential: "Jumlah Residential",
          nom_residential: "Nominal Residential",
          jlh_corporate: "Jumlah Corporate",
          nom_corporate: "Nominal Corporate",
          total: "Total",
        },
      ],
      csvHeader: [
        { label: "No", key: "no " },
        { label: "Tanggal", key: "tanggal " },
        { label: "Jumlah Mahasiswa", key: "jlh_mahasiswa " },
        { label: "Nominal Mahasiswa", key: "nom_mahasiswa " },
        { label: "Jumlah Residential", key: "jlh_residential " },
        { label: "Nominal Residential", key: "nom_residential " },
        { label: "Jumlah Corporate", key: "jlh_corporate " },
        { label: "Nominal Corporate", key: "nom_corporate " },
        { label: "Total", key: "total " },
      ],
      fileName: "Data_Invoice_Summary",
      csvFileName: "Data_Invoice_Summary.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataMember = (x) => {
  return {
    username: x.username,
    expiration: x.expiration,
    // address : x.address,
    nama_pelanggan: x.request_info ? x.request_info.nama : "",
    no_hp: x.request_info ? x.request_info.no_hp : "",
    email: x.request_info ? x.request_info.email : "",
    paket: x.request_info ? x.request_info.nama_packet : "",
    type: x.request_info ? x.request_info.type : "",
    alamat: x.request_info ? x.request_info.alamat : "",
    cluster: x.request_info ? x.request_info.nama_cluster : "",
  };
};

export const convertDataToExcelMember = (dataMember) => {
  if (dataMember.length > 0) {
    const record = dataMember.map((x) => formatDataMember(x));

    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) => (x.username ? x.username.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.expiration ? x.expiration.length : 0)),
        ),
      },
      // { wch: Math.max(...record.map(x => x.address ? x.address.length : 0 )) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nama_pelanggan ? x.nama_pelanggan.length : 0,
          ),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.no_hp ? x.no_hp.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.email ? x.email.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.paket ? x.paket.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
      {
        wch: Math.max(...record.map((x) => (x.cluster ? x.cluster.length : 0))),
      },
    ];
    const multiDataSet = {
      header: [
        "Username",
        "Date Expiration",
        // "Alamat Radius",
        "Nama Pelanggan Radius",
        "No HP Radius",
        "Email Radius",
        "Paket",
        "Type",
        "Alamat Pelanggan",
        "Cluster",
      ],
      heading: [
        {
          username: "Username",
          expiration: "Date Expiration",
          // address : "Alamat Radius",
          nama_pelanggan: "Nama Pelanggan Radius",
          no_hp: "No HP Radius",
          email: "Email Radius",
          paket: "Paket",
          type: "Type",
          alamat: "Alamat Pelanggan",
          cluster: "Cluster",
        },
      ],
      csvHeader: [
        { label: "Username", key: "username" },
        { label: "Date Expiration", key: "expiration" },
        // {label : "Alamat Radius", key : "address"},
        { label: "Nama Pelanggan Radius", key: "nama_pelanggan" },
        { label: "No HP Radius", key: "no_hp" },
        { label: "Email Radius", key: "email" },
        { label: "Paket", key: "paket" },
        { label: "Type", key: "type" },
        { label: "Alamat Pelanggan", key: "alamat" },
        { label: "Cluster", key: "cluster" },
      ],
      fileName: "Data_Member",
      csvFileName: "Data_Member.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataAccount = (x) => {
  return {
    no_hp: x.no_hp,
    name: x.name,
    request_id: x.request_id,
    email: x.email,
    status: x.status,
    last_payment_mode: x.last_payment_mode,
    nama_cluster: x.nama_cluster,
    username_radius: x.username_radius,
    tgl_selesai_instalasi: x.tgl_selesai_instalasi,
    created_at: x.created_at,
    last_payment_created_at: x.last_payment_created_at,
    first_payment_faspay: x.first_payment_faspay,
  };
};

export const convertDataToExcelAccount = (dataAccount) => {
  if (dataAccount.length > 0) {
    const record = dataAccount.map((x) => formatDataAccount(x));

    const wscols = [
      { wch: Math.max(...record.map((x) => (x.no_hp ? x.no_hp.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.name ? x.name.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.email ? x.email.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.status ? x.status.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.last_payment_mode ? x.last_payment_mode.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.username_radius ? x.username_radius.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.tgl_selesai_instalasi ? x.tgl_selesai_instalasi.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.created_at ? x.created_at.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.last_payment_created_at ? x.last_payment_created_at.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.first_payment_faspay ? x.first_payment_faspay.length : 0,
          ),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Nomor HP",
        "Nama",
        "Request No",
        "Email",
        "Type Pembayaran Terakhir",
        "Mode Pembayaran Terakhir",
        "Cluster",
        "Username",
        "Tanggal Instalasi",
        "Created At",
        "Last Payment At",
        "First Payment Faspay",
      ],
      heading: [
        {
          no_hp: "Nomor HP",
          name: "Nama",
          request_id: "Request No",
          email: "Email",
          status: "Type Pembayaran Terakhir",
          last_payment_mode: "Mode Pembayaran Terakhir",
          nama_cluster: "Cluster",
          username_radius: "Username",
          tgl_selesai_instalasi: "Tanggal Instalasi",
          created_at: "Created At",
          last_payment_created_at: "Last Payment At",
          first_payment_faspay: "First Payment Faspay",
        },
      ],
      csvHeader: [
        { label: "Nomor HP", key: "no_hp" },
        { label: "Nama", key: "name" },
        { label: "Request No", key: "request_id" },
        { label: "Email", key: "email" },
        { label: "Type Pembayaran Terakhir", key: "status" },
        { label: "Mode Pembayaran Terakhir", key: "last_payment_mode" },
        { label: "Cluster", key: "nama_cluster" },
        { label: "Username", key: "username_radius" },
        { label: "Tanggal Instalasi", key: "tgl_selesai_instalasi" },
        { label: "Created At", key: "created_at" },
        { label: "Last Payment At", key: "last_payment_created_at" },
        { label: "First Payment Faspay", key: "first_payment_faspay" },
      ],
      fileName: "Data_Account",
      csvFileName: "Data_Account.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatStatusIdleAsset = (x) => {
  let status = "";
  switch (x) {
    case true:
      status = "Tersedia";
      break;
    case false:
      status = "Tidak Tersedia";
      break;
  }
  return status;
};

const formatStatusImplementationAsset = (x) => {
  let status = "";
  switch (x) {
    case "In Stock":
      status = "Di Gudang";
      break;
    case "Carry":
      status = "Dibawa teknisi";
      break;
    case "Installed":
      status = "Terpasang";
      break;
  }
  return status;
};

const formatStatusTransferAsset = (x) => {
  let status = "";
  switch (x) {
    case "Idle":
      status = "Di Gudang";
      break;
    case "OnDelivery":
      status = "Ditransfer";
      break;
  }
  return status;
};

const formatDataAsset = (x) => {
  return {
    code: x.code,
    tgl_masuk: x.tgl_masuk,
    wh_address: x.wh_address,
    price: x.price,
    sn: x.sn,
    catalog: x.catalog,
    status_idle: formatStatusIdleAsset(x.status_idle),
    status_item: x.status_item,
    status_asset: x.status_asset,
    status_transfer: formatStatusTransferAsset(x.status_transfer),
    status_implementation: formatStatusImplementationAsset(
      x.status_implementation,
    ),
    username_radius: x.request_info?.username_radius,
    port_code: x.request_info?.port_code,
    vendor: x.vendor,
  };
};

export const convertDataToExcelAsset = (dataAsset) => {
  if (dataAsset.length > 0) {
    const record = dataAsset.map((x) => formatDataAsset(x));
    const wscols = [
      { wch: Math.max(...record.map((x) => (x.code ? x.code.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.tgl_masuk ? x.tgl_masuk.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.wh_address ? x.wh_address.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.price ? x.price.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.sn ? x.sn.length : 0))) },
      {
        wch: Math.max(...record.map((x) => (x.catalog ? x.catalog.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.status_idle ? x.status_idle.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.status_item ? x.status_item.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.status_asset ? x.status_asset.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_transfer ? x.status_transfer.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_implementation ? x.status_implementation.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.username_radius ? x.username_radius.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.port_code ? x.port_code.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.vendor ? x.vendor.length : 0))) },
    ];
    const multiDataSet = {
      header: [
        "Code",
        "Tgl Masuk",
        "WH Address",
        "Harga",
        "SN",
        "Catalog",
        "Idle",
        "Status Barang",
        "Condition",
        "Status Transfer",
        "Status Implementation",
        "Username",
        "Port",
        "Vendor",
      ],
      heading: [
        {
          code: "Code",
          tgl_masuk: "Tgl Masuk",
          wh_address: "WH Address",
          price: "Harga",
          sn: "SN",
          catalog: "Catalog",
          status_idle: "Idle",
          status_item: "Status Barang",
          status_asset: "Condition",
          status_transfer: "Status Transfer",
          status_implementation: "Status Implementation",
          username_radius: "Username",
          port_code: "Port",
          vendor: "Vendor",
        },
      ],
      csvHeader: [
        { label: "Code", key: "code" },
        { label: "Tgl Masuk", key: "tgl_masuk" },
        { label: "WH Address", key: "wh_address" },
        { label: "Harga", key: "price" },
        { label: "SN", key: "sn" },
        { label: "Catalog", key: "catalog" },
        { label: "Idle", key: "status_idle" },
        { label: "Status Barang", key: "status_item" },
        { label: "Condition", key: "status_asset" },
        { label: "Status Transfer", key: "status_transfer" },
        { label: "Status Implementation", key: "status_implementation" },
        { label: "Username", key: "username_radius" },
        { label: "Port", key: "port_code" },
        { label: "Vendor", key: "vendor" },
      ],
      fileName: "Data_Asset",
      csvFileName: "Data_Asset.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataExpiration = (x) => {
  return {
    request_id: x.request_id,
    type: x.type,
    nama: x.nama,
    no_hp: x.no_hp,
    username_radius: x.username_radius,
    expiration: x.expiration,
    port_code: x.port_code,
    sn: x.sn,
    // longitude: x.longitude,
    // latitude: x.latitude,
    status_follow_up: x.status_follow_up,
    client_status: x.client_status,
    nama_packet: x.nama_packet,
    kapasitas: x.kapasitas,
    harga: x.harga,
    nama_kost: x.nama_kost,
    alamat: x.alamat,
    nama_cluster: x.nama_cluster,
    tanggal_request: x.tanggal_request,
    nama_sales: x.nama_sales,
    status_request: x.status_request,
    tgl_mulai_instalasi: x.tgl_mulai_instalasi,
    nama_pic_instalasi: x.nama_pic_instalasi,
  };
};

export const convertDataToExcelExpiration = (dataExpirationRecurring) => {
  if (dataExpirationRecurring.length > 0) {
    const record = dataExpirationRecurring.map((x) => formatDataExpiration(x));
    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.type ? x.type.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.no_hp ? x.no_hp.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.username_radius ? x.username_radius.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.expiration ? x.expiration.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.port_code ? x.port_code.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.sn ? x.sn.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_follow_up ? x.status_follow_up.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.client_status ? x.client_status.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_packet ? x.nama_packet.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.kapasitas ? x.kapasitas.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.harga ? x.harga.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.tanggal_request ? x.tanggal_request.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_sales ? x.nama_sales.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_request ? x.status_request.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.tgl_mulai_instalasi ? x.tgl_mulai_instalasi.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nama_pic_instalasi ? x.nama_pic_instalasi.length : 0,
          ),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Request ID",
        "Type",
        "Nama",
        "No HP",
        "Username",
        "Expiration",
        "Port",
        "SN",
        "Status",
        "Faspay",
        "Nama Packet",
        "Kapasitas",
        "Harga",
        "Nama Kost",
        "Alamat",
        "cluster",
        "Tanggal Request",
        "Sales",
        "Status ERP",
        "Tanggal mulai instalasi",
        "PIC Instalasi",
      ],
      heading: [
        {
          request_id: "Request ID",
          type: "Type",
          nama: "Nama",
          no_hp: "No HP",
          username_radius: "Username",
          expiration: "Expiration",
          port_code: "Port",
          sn: "SN",
          status_follow_up: "Status",
          client_status: "Faspay",
          nama_packet: "Nama Packet",
          kapasitas: "Kapasitas",
          harga: "Harga",
          nama_kost: "Nama Kost",
          alamat: "Alamat",
          nama_cluster: "cluster",
          tanggal_request: "Tanggal Request",
          nama_sales: "Sales",
          status_request: "Status ERP",
          tgl_mulai_instalasi: "Tanggal mulai instalasi",
          nama_pic_instalasi: "PIC Instalasi",
        },
      ],
      csvHeader: [
        { label: "Request ID", key: "request_id" },
        { label: "Type", key: "type" },
        { label: "Nama", key: "nama" },
        { label: "No HP", key: "no_hp" },
        { label: "Username", key: "username_radius" },
        { label: "Expiration", key: "expiration" },
        { label: "Port", key: "port_code" },
        { label: "SN", key: "sn" },
        { label: "Status", key: "status_follow_up" },
        { label: "Faspay", key: "client_status" },
        { label: "Nama Packet", key: "nama_packet" },
        { label: "Kapasitas", key: "kapasitas" },
        { label: "Harga", key: "harga" },
        { label: "Nama Kost", key: "nama_kost" },
        { label: "Alamat", key: "alamat" },
        { label: "cluster", key: "nama_cluster" },
        { label: "Tanggal Request", key: "tanggal_request" },
        { label: "Sales", key: "nama_sales" },
        { label: "Status ERP", key: "status_request" },
        { label: "Tanggal mulai instalasi", key: "tgl_mulai_instalasi" },
        { label: "PIC Instalasi", key: "nama_pic_instalasi" },
      ],
      fileName: "Data_Expiration_Recurring",
      csvFileName: "Data_Expiration_Recurring.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataFollowupHistory = (x) => {
  const follow_up_info = x.follow_up_info;
  const pic_info = x.pic_info;
  const request_info = x.follow_up_info.request_info;
  return {
    status_follow_up: request_info.status_follow_up,
    no_hp: request_info.no_hp,
    nama: request_info.nama,
    username_radius: request_info.username_radius,
    begin_date: follow_up_info.begin_date,
    end_date: follow_up_info.end_date,
    expiration: follow_up_info.expiration,
    pic_name: pic_info.name,
    status: x.status,
    dismantle_category_description: x.dismantle_category_description,
    description_followup: x.description,
    request_id: request_info.request_id,
    port_code: request_info.port_code,
    sn: request_info.sn,
    client_status: request_info.client_status,
    nama_packet: request_info.nama_packet,
    kapasitas: request_info.kapasitas,
    harga: request_info.harga,
    nama_kost: request_info.nama_kost,
    alamat: request_info.alamat,
    nama_cluster: request_info.nama_cluster,
  };
};

export const convertDataToExcelFollowupHistory = (
  dataFollowupHistoryRecurring,
) => {
  if (dataFollowupHistoryRecurring.length > 0) {
    const record = dataFollowupHistoryRecurring.map((x) =>
      formatDataFollowupHistory(x),
    );
    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_follow_up ? x.status_follow_up.length : 0,
          ),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.no_hp ? x.no_hp.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.username_radius ? x.username_radius.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.begin_date ? x.begin_date.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.end_date ? x.end_date.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.expiration ? x.expiration.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.pic_name ? x.pic_name.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.status ? x.status.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.dismantle_category_description
              ? x.dismantle_category_description.length
              : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.description_followup ? x.description_followup.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.request_id ? x.request_id.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.port_code ? x.port_code.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.sn ? x.sn.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.client_status ? x.client_status.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_packet ? x.nama_packet.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.kapasitas ? x.kapasitas.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.harga ? x.harga.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_kost ? x.nama_kost.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_cluster ? x.nama_cluster.length : 0)),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "End Status",
        "No HP",
        "Nama",
        "Username",
        "Tanggal Mulai",
        "Tanggal Selesai",
        "Expiration",
        "PIC Followup",
        "Status Followup",
        "Dismantle Desc",
        "Hasil Followup",
        "Request ERP",
        "Port",
        "SN",
        "Faspay",
        "Nama Packet",
        "Kapasitas",
        "Harga",
        "Nama Kost",
        "Alamat",
        "Cluster",
      ],
      heading: [
        {
          status_follow_up: "End Status",
          no_hp: "No HP",
          nama: "Nama",
          username_radius: "Username",
          begin_date: "Tanggal Mulai",
          end_date: "Tanggal Selesai",
          expiration: "Expiration",
          pic_name: "PIC Followup",
          status: "Status Followup",
          dismantle_category_description: "Dismantle Desc",
          description_followup: "Hasil Followup",
          request_id: "Request ERP",
          port_code: "Port",
          sn: "SN",
          client_status: "Faspay",
          nama_packet: "Nama Packet",
          kapasitas: "Kapasitas",
          harga: "Harga",
          nama_kost: "Nama Kost",
          alamat: "Alamat",
          nama_cluster: "Cluster",
        },
      ],
      csvHeader: [
        { label: "End Status", key: "status_follow_up" },
        { label: "No HP", key: "no_hp" },
        { label: "Nama", key: "nama" },
        { label: "Username", key: "username_radius" },
        { label: "Tanggal Mulai", key: "begin_date" },
        { label: "Tanggal Selesai", key: "end_date" },
        { label: "Expiration", key: "expiration" },
        { label: "PIC Followup", key: "pic_name" },
        { label: "Status Followup", key: "status" },
        { label: "Dismantle Desc", key: "dismantle_category_description" },
        { label: "Hasil Followup", key: "description_followup" },
        { label: "Request ERP", key: "request_id" },
        { label: "Port", key: "port_code" },
        { label: "SN", key: "sn" },
        { label: "Faspay", key: "client_status" },
        { label: "Nama Packet", key: "nama_packet" },
        { label: "Kapasitas", key: "kapasitas" },
        { label: "Harga", key: "harga" },
        { label: "Nama Kost", key: "nama_kost" },
        { label: "Alamat", key: "alamat" },
        { label: "Cluster", key: "nama_cluster" },
      ],
      fileName: "Data_Followup_Recurring",
      csvFileName: "Data_Followup_Recurring.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataKost = (x) => {
  return {
    nama: x.nama,
    alamat: x.alamat,
    kelurahan: x.kelurahan,
    jumlah_kamar: x.jumlah_kamar,
    nama_pemilik: x.nama_pemilik,
    hp_pemilik: x.hp_pemilik,
    nama_pengelola: x.nama_pengelola,
    hp_pengelola: x.hp_pengelola,
    status_kemitraan: x.status_kemitraan,
    masa_berlaku_mitra: x.masa_berlaku_mitra,
    latitude: x.latitude,
    longitude: x.longitude,
    no_pks: x.no_pks,
    upload_pks: x.upload_pks,
    cluster_nama: x.cluster_info.nama_cluster,
    fee_keeper: x.fee_keeper,
  };
};

export const convertDataToExcelKost = (dataKost) => {
  if (dataKost.length > 0) {
    const record = dataKost.map((x) => formatDataKost(x));
    const wscols = [
      { wch: Math.max(...record.map((x) => (x.nama ? x.nama.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.alamat ? x.alamat.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.kelurahan ? x.kelurahan.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.jumlah_kamar ? x.jumlah_kamar.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.nama_pemilik ? x.nama_pemilik.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.hp_pemilik ? x.hp_pemilik.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.nama_pengelola ? x.nama_pengelola.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.hp_pengelola ? x.hp_pengelola.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.status_kemitraan ? x.status_kemitraan.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.masa_berlaku_mitra ? x.masa_berlaku_mitra.length : 0,
          ),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.latitude ? x.latitude.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.longitude ? x.longitude.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.no_pks ? x.no_pks.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.upload_pks ? x.upload_pks.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.cluster_nama ? x.cluster_nama.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.fee_keeper ? x.fee_keeper.length : 0)),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Nama",
        "Alamat",
        "Kelurahan",
        "Jumlah Kamar",
        "Nama Pemilik",
        "HP Pemilik",
        "Nama Pengelola",
        "HP Pengelola",
        "Status Kemitraan",
        "Masa Berlaku Mitra",
        "Latitude",
        "Longitude",
        "No Pks",
        "Upload Pks",
        "Cluster",
        "Fee Penjaga",
      ],
      heading: [
        {
          nama: "Nama",
          alamat: "Alamat",
          kelurahan: "Kelurahan",
          jumlah_kamar: "Jumlah Kamar",
          nama_pemilik: "Nama Pemilik",
          hp_pemilik: "HP Pemilik",
          nama_pengelola: "Nama Pengelola",
          hp_pengelola: "HP Pengelola",
          status_kemitraan: "Status Kemitraan",
          masa_berlaku_mitra: "Masa Berlaku Mitra",
          latitude: "Latitude",
          longitude: "Longitude",
          no_pks: "No Pks",
          upload_pks: "Upload Pks",
          cluster_nama: "Cluster",
          fee_keeper: "Fee Penjaga",
        },
      ],
      csvHeader: [
        { label: "Nama", key: "nama" },
        { label: "Alamat", key: "alamat" },
        { label: "Kelurahan", key: "kelurahan" },
        { label: "Jumlah Kamar", key: "jumlah_kamar" },
        { label: "Nama Pemilik", key: "nama_pemilik" },
        { label: "HP Pemilik", key: "hp_pemilik" },
        { label: "Nama Pengelola", key: "nama_pengelola" },
        { label: "HP Pengelola", key: "hp_pengelola" },
        { label: "Status Kemitraan", key: "status_kemitraan" },
        { label: "Masa Berlaku Mitra", key: "masa_berlaku_mitra" },
        { label: "Latitude", key: "latitude" },
        { label: "Longitude", key: "longitude" },
        { label: "No Pks", key: "no_pks" },
        { label: "Upload Pks", key: "upload_pks" },
        { label: "Cluster", key: "cluster_nama" },
        { label: "Fee Penjaga", key: "fee_keeper" },
      ],
      fileName: "Data_Kost",
      csvFileName: "Data_Kost.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataCarry = (x) => {
  let status = "";
  switch (x.status) {
    case "Carry":
      status = "Dibawa Teknisi";
      break;
    case "Closed":
      status = "Selesai";
      break;
    case "Cancelled":
      status = "Dikembalikan";
      break;
  }
  return {
    code: x.code,
    sn: x.sn,
    pic_name: x.pic_name,
    catalog_type: x.catalog_type,
    status: status,
    out_date: x.out_date,
    in_date: x.in_date,
    description: x.description,
    asset: x.asset,
  };
};

export const convertDataToExcelCarry = (dataKost) => {
  if (dataKost.length > 0) {
    const record = dataKost.map((x) => formatDataCarry(x));
    const wscols = [
      { wch: Math.max(...record.map((x) => (x.code ? x.code.length : 0))) },
      { wch: Math.max(...record.map((x) => (x.sn ? x.sn.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.pic_name ? x.pic_name.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.catalog_type ? x.catalog_type.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.status ? x.status.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.out_date ? x.out_date.length : 0)),
        ),
      },
      {
        wch: Math.max(...record.map((x) => (x.in_date ? x.in_date.length : 0))),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.description ? x.description.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.asset ? x.asset.length : 0))) },
    ];
    const multiDataSet = {
      header: [
        "Code",
        "SN",
        "PIC",
        "Catalog Type",
        "Status",
        "Keluar",
        "Masuk",
        "Deskripsi",
        "Asset",
      ],
      heading: [
        {
          code: "Code",
          sn: "SN",
          pic_name: "PIC",
          catalog_type: "Catalog Type",
          status: "Status",
          out_date: "Keluar",
          in_date: "Masuk",
          description: "Deskripsi",
          asset: "Asset",
        },
      ],
      csvHeader: [
        { label: "Code", key: "code" },
        { label: "SN", key: "sn" },
        { label: "PIC", key: "pic_name" },
        { label: "Catalog Type", key: "catalog_type" },
        { label: "Status", key: "status" },
        { label: "Keluar", key: "out_date" },
        { label: "Masuk", key: "in_date" },
        { label: "Deskripsi", key: "description" },
        { label: "Asset", key: "asset" },
      ],
      fileName: "Data_Carry",
      csvFileName: "Data_Carry.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataFaspay = (x) => {
  let status = "";
  switch (x.status) {
    case 0:
      status = "Waiting";
      break;
    case 2:
      status = "Success";
      break;
  }
  return {
    created_at: x.created_at,
    status: status,
    payment_date: x.payment_date,
    cust_name: x.cust_name,
    bill_total: x.bill_total,
    merchant_id: x.merchant_id,
    bill_date: x.bill_date,
    bill_expired: x.bill_expired,
    bill_desc: x.bill_desc,
    payment_channel: x.payment_channel,
  };
};

export const convertDataToExcelFaspay = (dataFaspay) => {
  if (dataFaspay.length > 0) {
    const record = dataFaspay.map((x) => formatDataFaspay(x));
    const wscols = [
      {
        wch: Math.max(
          ...record.map((x) => (x.created_at ? x.created_at.length : 0)),
        ),
      },
      { wch: Math.max(...record.map((x) => (x.status ? x.status.length : 0))) },
      {
        wch: Math.max(
          ...record.map((x) => (x.payment_date ? x.payment_date.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.cust_name ? x.cust_name.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.bill_total ? x.bill_total.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.merchant_id ? x.merchant_id.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.bill_date ? x.bill_date.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.bill_expired ? x.bill_expired.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) => (x.bill_desc ? x.bill_desc.length : 0)),
        ),
      },
      {
        wch: Math.max(
          ...record.map((x) =>
            x.payment_channel ? x.payment_channel.length : 0,
          ),
        ),
      },
    ];
    const multiDataSet = {
      header: [
        "Created",
        "Status",
        "Payment Date",
        "Nama",
        "Price",
        "Merchant",
        "Bill Date",
        "Bill Expired Date",
        "Deskripsi",
        "Bank",
      ],
      heading: [
        {
          created_at: "Created",
          status: "Status",
          payment_date: "Payment Date",
          cust_name: "Nama",
          bill_total: "Price",
          merchant_id: "Merchant",
          bill_date: "Bill Date",
          bill_expired: "Bill Expired Date",
          bill_desc: "Deskripsi",
          payment_channel: "Bank",
        },
      ],
      csvHeader: [
        { label: "Created", key: "created_at" },
        { label: "Status", key: "status" },
        { label: "Payment Date", key: "payment_date" },
        { label: "Nama", key: "cust_name" },
        { label: "Price", key: "bill_total" },
        { label: "Merchant", key: "merchant_id" },
        { label: "Bill Date", key: "bill_date" },
        { label: "Bill Expired Date", key: "bill_expired" },
        { label: "Deskripsi", key: "bill_desc" },
        { label: "Bank", key: "payment_channel" },
      ],
      fileName: "Data_Faspay",
      csvFileName: "Data_Faspay.csv",
      wscols: wscols,
      csvData: record,
    };
    return multiDataSet;
  } else {
    return null;
  }
  //return newBlob;
};

const formatDataInvoiceGenerateMitra = (x) => {
  return {
    username: x.username_radius,
    createdate: x.createdate,
    price: x.price,
  };
};

export const convertDataToInvoiceGenerateMitra = (dataInvoice) => {
  if (dataInvoice.length > 0) {
    const record = dataInvoice.map((x) => formatDataInvoiceGenerateMitra(x));

    return record;
  } else {
    return [];
  }
  //return newBlob;
};

export const convertBase64ToFile = (file) => { 
  const mime = data_type.filter((x) => x.includes(file.match(/^data:.*;/g))); 
  if (mime.length === 0) { 
    toast.error("unsupported type file"); 
    return null;
  }
  const byteString = atob(file.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  const newBlob = new Blob([ab], {
    type: mime[0].replace(/(data:|;)+/g, ""),
  });
  console.log(newBlob);
  var csvURL = window.URL.createObjectURL(newBlob);
  let tempLink = document.createElement("a");
  tempLink.href = csvURL;
  tempLink.setAttribute("download", "filename");
  tempLink.click(); 
  //return newBlob; 
}; 

export const previewAttachment = (file) => {
  if (!file) {
    toast.error("No data to preview");
    return;
  }

  if (/^https?:\/\//.test(file)) {
    window.open(file, "_blank");
    return;
  }

  convertBase64ToFile(file);
};
 
export const convertBase64ToBlob = (file) => { 
  const mime = data_type.filter((x) => x.includes(file.match(/^data:.*;/g)));
  if (mime.length === 0) {
    toast.error("unsupported type file");
    return null;
  }
  const byteString = atob(file.split(",")[1]);
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  const newBlob = new Blob([ab], {
    type: mime[0].replace(/(data:|;)+/g, ""),
  });
  return window.URL.createObjectURL(newBlob);
};

//async compress photo
const compressFile = async (file) => {
  const options = {
    maxSizeMB: 0.5,
    maxWidthOrHeight: 1024,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(file, options);
    //console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB
    return { status: true, file: compressedFile };
  } catch (error) {
    console.log(error);
    return { status: false, error: error };
  }
};

export const getBase64 = (file, cb) => {
  if (
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
    file.type === "application/pdf"
  ) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
      cb(reader.result);
    };
    reader.onerror = function(error) {
      console.log("Error: ", error);
    };
  } else {
    const compressedFile = compressFile(file);
    compressedFile.then((response) => {
      //dispatch(actions.progressUpdated({ progress }));
      let reader = new FileReader();

      reader.readAsDataURL(response.file);
      reader.onload = function() {
        cb(reader.result);
      };
      reader.onerror = function(error) {
        console.log("Error: ", error);
      };
    });
  }
};

export const convertExcelToJson = (f, cb) => {
  //var name = f.name;
  const reader = new FileReader();
  reader.readAsBinaryString(f);
  reader.onload = (evt) => {
    // evt = on_file_select event
    /* Parse data */
    const bstr = evt.target.result;
    const wb = XLSX.read(bstr, { type: "binary" });
    /* Get first worksheet */
    const wsname = wb.SheetNames[1];
    const ws = wb.Sheets[wsname];
    /* Convert array of arrays */
    const data = XLSX.utils.sheet_to_csv(ws, { header: 1, FS: "|" });
    /* Update state */
    //console.log("Data>>>" + data);// shows that excel data is read
    //console.log(convertToJson(data)); // shows data in json format
    cb(convertToJson(data));
  };
};

const convertToJson = (csv) => {
  var lines = csv.split("\n");

  var result = [];

  var headers = lines[0].split("|");

  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split("|");

    for (var j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j];
    }

    result.push(obj);
  }

  //return result; //JavaScript object
  return result; //JSON
};
